import { keysIn } from "lodash"

export const _keysType = <T extends unknown>(data: T): (keyof T)[] => {
    return keysIn(data) as any
}
;(window as any).keysType = _keysType
